import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { StudentDailyAttendanceComponent } from './student-daily-attendance/student-daily-attendance.component';
import { StudentMonthlyAttendanceComponent } from './student-monthly-attendance/student-monthly-attendance.component';
import { ConsolidatedDailyAttendanceComponent } from './consolidated-daily-attendance/consolidated-daily-attendance.component';
import { AttendanceMonthlyReportComponent } from './attendance-monthly-report/attendance-monthly-report.component';
import { AttendanceSummaryReportComponent } from './attendance-summary-report/attendance-summary-report.component';
import { AttendanceMonthlyReportPrintComponent } from './attendance-monthly-report-print/attendance-monthly-report-print.component';
import { AttendanceSummaryReportPrintComponent } from './attendance-summary-report-print/attendance-summary-report-print.component';
import { MonthlyStudentAttendanceComponent } from './monthly-student-attendance/monthly-student-attendance.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'studentdailyattendance', component: StudentDailyAttendanceComponent, pathMatch: 'full' },
      { path: 'studentmonthlyattendance', component: StudentMonthlyAttendanceComponent, pathMatch: 'full' },
      { path: 'attendancemonthlyreport', component: AttendanceMonthlyReportComponent, pathMatch: 'full' },
      { path: 'attendancesummaryreport', component: AttendanceSummaryReportComponent, pathMatch: 'full' },
      { path: 'consolidateddailyattendance', component: ConsolidatedDailyAttendanceComponent, pathMatch: 'full' },
      { path: 'monthlystudentattendance', component: MonthlyStudentAttendanceComponent, pathMatch: 'full' },


    ]
  },
  {
    path: '', children: [      
      { path: 'attendancemonthlyreportprint', component: AttendanceMonthlyReportPrintComponent, pathMatch: 'full' },
      { path: 'attendancesummaryreportprint', component: AttendanceSummaryReportPrintComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendanceRoutingModule { }
